export default {
    title: '三井塑料贸易（上海）有限公司',
    subTit: 'MITSUI PLASTICS TRADING (SHANGHAI) CO., LTD',
    home: {
        changeLang: 'EN',
    },
    pageTabbar: {
        tab1: 'Home',
        tab2: 'Company Profile',
        tab3: 'Areas',
        tab4: 'Functions',
        tab5: 'Products',
        tab6: 'Stock Points',
        tab7: 'Contact Us',
    },
    bottom: {
        title: 'CONTACT',
        company1: 'MITSUI PLASTICS TRADING (SHANGHAI) CO.,LTD',
        com1_span1: 'Address:19th Floor, Hong Shou Fang East Tower, No. 1143, Xikang Road, Putuo District, Shanghai',
        com1_span2: 'Tel：86(21)2223-6666',
        com1_span3: 'Fax：86(21)2223-6699',
        com1_span4: "Email：PlanningSHMPS{'@'}dg.mitsui.com",
        company2: 'MITSUI PLASTICS TRADING(SHANGHAI)CO.,LTD.GUANGZHOU BRANCH',
        com2_span1: 'Address：Room 3601 OneLinkCenter,230 Tianhe Road, Tianhe District, Guangzhou 510620 China',
        com2_span2: 'Tel：020-2887-0288',
        com2_span3: 'Fax：020-2887-0299',

        
        
        company3: 'MITSUI PLASTICS TRADING(SHANGHAI)CO.,LTD. NANJING BRANCH',
        com3_span1: 'Address：Naniing,jinglin-Asia Pacific Tower Room 890,8/F jinling Hotel Asia Pacific Tower,No.2,Hanzhong Road,Gulou District, Nanjing China.(〒210005)',
        com3_span2: 'Tel：13472511541',
        company4: 'MITSUI PLASTICS TRADING(SHANGHAI)CO.,LTD. SUZHOU OFFICE',
        com4_span1: 'Address：Suzhou,Jinghope Plaza Room 3016,30/F, Tower 1,Jinghope Plaza,88 Hua Chi Street,SIP,Suzhou China.(〒215021)',
        com4_span2: 'Tel：13472519247',
        com4_span3: 'Tel：(0512)6762-8868',

        botSpan1: 'COPYRIGHT 2003-2017 MITSUI PLASTICS TRADING (SHANGHAI) CO., LTD.ALL ',
        botSpan2: 'RIGHTS RESERVED 沪ICP备12001177号-1',
        botSpan3: '沪公网安备 31010702007338号',
        botSpan4: '沪(浦)应急管危经许[2023]203699',
    },
    index: {
        banner: {
            span1: 'MITSUI PLASTICS TRADING (SHANGHAI) CO.,LTD. established in 2003, joint invested by Mitsui & Co Ltd, Mitsui & Co (Shanghai) Ltd and Mitsui & Co (China) Ltd, registered in China (Shanghai) Pilot Free Trading Zone, is mainly engaged in the business of import & export, bonded and domestic business for functional materials (plastics resins, products, inorganic products) and advanced materials (electronic parts etc).',
            span2: 'Our company, as the subsidiary of Mitsui & Co. Group and H.Q. of Sales and Marketing in China for functional and advanced materials, we have been offering JIT and other logistics solutions to our customers by our inventory and distribution functions with nearly 30 stock points in the whole mainland in China.'
        },
        one: {
            span1: 'ABOUT US <br/><br/>',
            span2: 'MITSUI PLASTICS TRADING (SHANGHAI) CO.,LTD. established in 2003, joint invested by Mitsui & Co Ltd, Mitsui & Co (Shanghai) Ltd and Mitsui & Co (China) Ltd, registered in China (Shanghai) Pilot Free Trading Zone, is mainly engaged in the business of import & export, bonded and domestic business for functional materials (plastics resins, products, inorganic products) and advanced materials (electronic parts etc). Our company, as the subsidiary of Mitsui & Co. Group and H.Q. of Sales and Marketing in China for functional and advanced materials, we have been offering JIT and other logistics solutions to our customers by our inventory and distribution functions with nearly 30 stock points in the whole mainland in China.',
            span3: "In November 2018, we established Guangzhou Branch to meet the growing market demand of South China by utilizing our functions such as Stock Operations, JIT and other Logistics solutions, Sales and Marketing, etc.). Furthermore, we opened Nanjing office in June and Suzhou office in July 2019 to expand our operations for the market in Jiangsu, Anhui, Hubei Province and so on. By using Mitsui's global network and integrated business power, MITSUI PLASTICS TRADING (SHANGHAI) CO.,LTD.  is proactively to enhance our services and functions to contribute to Chinese economic growth and development. ",
        },
        two: {
            span1: 'Areas <br/><br/>',
            span2: 'As a consolidated subsidiary of Mitsui & Co.,Ltd, we are mainly engaged in the business for functional materials and advanced materials.',
            span3: '<br/><br/>Functions<br/><br/>',
            span4: 'Solution Provider, Global Network, Sales & Marketing, Good Distribution & Stock Operation',

        },
        three: {
            span1: 'Products <br/><br/>',
            span2: 'MITSUI PLASTICS TRADING (SHANGHAI) CO.,LTD. deals with engineering plastics, performance plastics, nylon film, chloroprene rubber, titanium dioxide and advanced materials, etc.',
            span3: '<br/><br/> Stock Points <br/><br/>',
            span4: 'MITSUI PLASTICS TRADING (SHANGHAI) CO.,LTD. has 23 stock spots (18 cities) in the China mainland, able to provide high quality logistics service to our customer effectivity.',
        },
        gs: {
            title: 'Corporate name',
            gs1: 'MITSUI & CO.(CHINA) LTD.',
            gs2: 'MITSUI & CO.(CHINA) LTD. Northeast Branch',
            gs3: 'MITSUI & CO.(CHINA) LTD. Changchun Branch',
            gs4: 'MITSUI & CO.(CHINA) LTD. Shenyang Office',
            gs5: 'MITSUI & CO.(CHINA) LTD. Tianjin Branch',
            gs6: 'MITSUI & CO.(CHINA) LTD. Qingdao Branch',
            gs7: 'MITSUI & CO.(CHINA) LTD. Huhhot Office',
            gs8: 'MITSUI & CO.(SHANGHAI) LTD.',
            gs9: 'MITSUI & CO.(SHANGHAI) LTD. Wuhan Branch',
            gs10: 'MITSUI & CO.(SHANGHAI) LTD. Southwest Branch',
            gs11: 'MITSUI & CO.(SHANGHAI) LTD. Southwest Branch Chengdu Office',
            gs12: 'MITSUI & CO.(GUANGDONG) LTD.',
            gs13: 'MITSUI & CO.(GUANGDONG) LTD. Changsha Office',
            gs14: 'MITSUI & CO. (HONG KONG) LTD.',
        }
    },
    company: {
        title1: 'Company Profile',
        line1_1_1: 'Company Name (Chinese)',
        line1_1_2: '三井塑料贸易(上海)有限公司',
        line1_2_1: 'Company Name (English)',
        line1_2_2: 'Mitsui Plastics Trading Shanghai Co., Ltd.',
        line1_3_1: 'Head Office Address',
        line1_3_2: '19th Floor, Hong Shou Fang East Tower, No. 1143, Xikang Road, Putuo District, Shanghai.(-200042)',
        line1_4_1: 'Reqistered Address',
        line1_4_2: 'Room 1006, Waigaoqiao Building, 6 ji Long Rd, Waigaoqiao FTZ Shanghai, PR.C. (200131)',
        line1_5_1: 'Business Areas',
        line1_5_2: 'Import and export of functional Materials,Advanced Materials,Tripartite trade, Bonded area business,Domestic sales.',
        line1_6_1: 'Registered Capital',
        line1_6_2: 'US$300000',
        line1_7_1: 'Founded Date',
        line1_7_2: 'Mar 2003',
        line1_8_1: 'Shareholders',
        line1_8_2: 'MITSUI & CO. LTD (80%), MITSUI & CO.(CHINA) LTD. (10%), MITSUI & CO.(SHANGHAI) LTD (10%)',
        line1_9_1: 'Chairman ·President and CEO',
        line1_9_2: 'Itani Ryota',
        title2: 'Corporate History',
        line2_1_1: 'Mar 2003',
        line2_1_2: 'Mitsui Plastics Trading Shanghai Co, Ltd.was established in Waigaoqiao Shanghai FTZ ( MITSUI & CO, LTD 80% ,MITSUI & CO.(CHINA) LTD.10%,MITSUI & CO.(SHANGHAI) LTD 10%)',
        line2_2_1: 'Jan 2004',
        line2_2_2: 'Mitsui international Logistics& Trade(SuZhou)Co, Ltd (MlLTwas established (Suzhou Logistics Center 50%. MITSUl & CO. TD 40%、MITSUI & CO.(CHINA) LTD.10%)',
        line2_3_1: 'Jan 2007',
        line2_3_2: 'Inteqration of MPTS and MlLT and succeeded by MPTS.',
        line2_4_1: 'Nov 2018',
        line2_4_2: 'Established Guangzhou Branch.',
        line2_5_1: 'Jun 2019',
        line2_5_2: 'Established Nanjing Office.',
        line2_6_1: 'Jul 2019',
        line2_6_2: 'Established Suzhou Office.',
        line2_7_1: 'Nov 2022',
        line2_7_2: 'Established Nanjing Branch.',
        title3: 'Corporate',
        line3_1_1: 'Head Office',
        line3_1_2: '19th Floor, Hong Shou Fang East Tower, No. 1143, Xikang Road, Putuo District, Shanghai. (〒200042)',
        line3_1_3: 'Tel. +86-21-2223-6666',
        line3_1_4: 'Direct subway line7 「Changshou Road」 Station.',
        line3_2_1: 'Guangzhou Branch',
        line3_2_2: 'Room 3601 OneLinkCenter,230 Tianhe Road,Guangzhou China.(〒510620)',
        line3_2_3: 'Tel.+86-20-2887-0288',
        line3_3_1: 'Suzhou office',
        line3_3_2: 'Suzhou,Jinghope Plaza Room 3016,30/F, Tower 1,Jinghope Plaza,88 Hua Chi Street,SIP,Suzhou China.(〒215021)',
        line3_3_3: 'Tel.+86-512-6762-8828',
        line3_4_1: 'Nanjing Branch',
        line3_4_2: 'Naniing,jinglin-Asia Pacific Tower Room 890,8/F jinling Hotel Asia Pacific Tower,No.2,Hanzhong Road,Gulou District, Nanjing China.(〒210005)',
        line3_4_3: 'Tel. +86-134-7251-1541',
    },
    main: {
        main: {
            tit: 'Mitsui Plastics Trading (Shanghai) Co., LTD',
            span1: 'Distributor of Functional/Advanced Materials.',
            span2: 'Consolidated Subsidiary of Mitsui & Co.',
        },
        item1: {
            tit: 'Infrastructure Material',
            text: 'PVC Resin, Modifier for Pipe, Silicone products, Window Modifier、 Modified Silicone、 Paint etc.'
        },
        item2: {
            tit: 'OA·Home Appliance',
            text: 'Functional Resin (Engineering Plastics、 PS/ABS Modifier) Paint for Car Interior Decoration and Mobile,Silicone products, etc.'
        },
        item3: {
            tit: 'Automobile',
            text: 'PP Compounds ;Functional Resin (Engineering plastics, etc.) Chloroprene Rubber,Synthetic Rubber、Elastomer、 Foamed PP Compounds etc'
        },
        item4: {
            tit: 'Packaging Film',
            text: 'M-LLDPE·LDPE·POE Resin、 NY·PE·SPE Film, PPA etc.'
        },
        item5: {
            tit: 'Paint/Ink',
            text: 'TiO2,Titanium Ore'
        },
        item6: {
            tit: 'Electronic Material',
            text: 'Insulation Film, Copper Foil (For Printed Circuit Board) Thermal Conductivity Materials (Graphite Sheet, Resins) Films for Display Panel, Organic El materials'
        },
        item7: {
            tit: 'Industrial Machinery',
            text: 'Electric tools, Materials related to Construction Machinery. etc.'
        },
    },
    functions: {
        item1: {
            tit: 'Solution Provider',
            span1: 'Registered Customers :4,288',
            span2: 'Registered suppliers : 667 (as of oct.2023)',
            span3: '· Providing best solution.',
            span4: '· Credit risk taking.',
            span5: '· Cash flow supporting.',
        },
        item2: {
            tit: 'Good Distribution & Stock Operation',
            span1: '· 33 stock points in China.',
            span2: '· JIT(Just In Time) delivery from ourstock points in Bonded, Non-Bondedand Export Processing Zone.',
            span3: '· SCM(Supply Chain Management),DCM(Demand Chain Management)with shorter lead time, stable supply.(Automotive, Home Appliance, OA,Electronic parts.).',
            span4: '',
        },
        item3: {
            tit: 'Global Network',
            span1: "· Collaboration with MITSUI & Co.'s global network.",
            span2: '· Global Sourcing.',
            span3: '· Business Planning and Strategy.',
        },
        item4: {
            tit: 'Sales & Marketing',
            span1: '· About 90 sales staff with good experti.',
            span2: '· New business development.',
            span3: '· Good access to various industries.',
            span4: '· Excellent experience with Sales & Marketing.',
        },
    },
    products: {
        tit1: 'Depts.',
        tit2: 'Commodity',
        tit3: 'Field',
        tit4: 'Applications',

        line1_1: 'Consumer&Electronics',
        line1_2: 'Plastics,(PP,PB,PC,PBT,ABS,POM,PA,PPS,PPA,LCP,PES,TPX,PEEK,TPU etc.), Glass Fiber, master batch',
        line1_3: 'Automotive.OA,Power,tools, Household,Electronics',
        line1_4: 'Automotive parts, pipe,smart phone,camera, film,household application',

        line2_1: 'Industrial',
        line2_2: 'Synthetic Resin(PBT.PA,PA9T,PC,PPE,PBAT,TPU)',
        line2_3: 'Automotive, Electronics',
        line2_4: 'Motor, Breaker,Relay,Switch.etc.',

        line3_1: 'Engineering plastics',
        line3_2: 'Enaineering plastics.(PC,PB,ABS,POM,PA,PPS,LCP,PES,PAINTTPU.etc.)',
        line3_3: 'Automotive, OA, Power,Tool, Household,Electronics',
        line3_4: 'Precision Machinery,Accessories forAutomotive, Mobile Parts',

        line4_1: 'Industrial Materials',
        line4_2: 'PP compounds,TPV(MILASTOMER),Engineering plastics (ASA、PC/ABS)Shin-Etsu Silicones,Conductive aid,',
        line4_3: 'Automotive, Household,Automotive',
        line4_4: 'Automotive/Householdinteriors and exteriors,Battery, Reactor',

        line5_1: 'Elastomer',
        line5_2: 'Chloroprene Rubber, other SyntheticRubberGlass Cord, Rubber Additives',
        line5_3: 'Automotive, GeneralIndustry, Adhesive industry',
        line5_4: 'Automotive and industrial Rubber Parts, Adhesive',

        line6_1: 'Film Material',
        line6_2: 'Bariier Film、PE Film、 Biodegradable Film,M-LLDPE · POE · EVA · TPU Resin,PPA、Additives',
        line6_3: 'Printing industry, FilmMaker Compounding Marker',
        line6_4: 'Food Packaging、Industrial Packaging,Functional Film、SoalrMaterial、 PPF Material.Food Packaging',

        line7_1: 'Living & Environmental Materials',
        line7_2: 'Woodchip, Paper Product, Wooden Products, (Sawn timber, Log, MDF, Particle Board, etc.),Glass, Vacuum Insulation Panel, PCR Resins(rPPrPE,rPS,rABS,rPET etc.)',
        line7_3: 'Paper Manufacturing, Apparel, Food,Construction, Interior,Household Appliances Manufacturing, Automotive, Household Appliances, OA, Personal Care, Food',
        line7_4: 'Printing Paper, Tissue Paper, Industrial Living & EnvironmentalMaterials Woodchip, Paper Product, WoodenProducts, (Sawn timber, Log, MDF, ParticleBoard, etc.), Glass, Vacuum InsulationPanel, PCR Resins(rPPrPE, rPS, rABS, rPETetc.) Paper ManufacturingApparel, Food.Construction, Interior.Household AppliancesManufacturing, Automotive, HouseholdAppliances, OA.PersonaCare, Food .Engineering Paper, PaperPack, etc.Viscose rayon,Construction parts. Decoration reinforcing material, Furniture,Household Appliances parts, Parts for Household Appliances, OA. Automotive, Packages for Food, Personal Care Chemicals',

        line8_1: 'Performance Chemicals',
        line8_2: 'Titanium Dioxide, Silicone, Higer Olefins & Paraffin(LAO,DlB,IP), Oleo Chemicals(Fatty Acied, Glycerin), MS Polymer, Sealant additives, lodine, Kaolin Etc.',
        line8_3: 'Paint, Ink, Compound,Lubricating oil, MetalProcess oil, Additiveagent,Cosmetics, Rubbermolding, Film, Sealant,Adhesive, Electronics,Polymerization, Tire Etc.',
        line8_4: 'Paint, Ink, compound,Lubricant additives,Industrial lubricants, Tiremastics, Cosmetics.Automotive / Householdparts, Release film, Industry/ Constructionsealant, Electronics parts',

        line9_1: 'Polymer Additives',
        line9_2: 'Resin Modifier(MBS、ACR、Flame Retardant、 Anti-blocking agent、Lubricants、 Tribological property improver、Nucleating agent、 etc.),epoxy toughener, Eperan EPP、 PVC Paste、PC resin etc.',
        line9_3: 'Compound、Resin molding, Wind-powergeneration、Automobiles,Automobiles、Compound,Polymerization, Adhesive, Etc.',
        line9_4: 'Compound、Resin molding, Adhesives、composite materials, Sunvisor、return box、gloves、compound,Adhesive.(Automotive,Electronics)',

        line10_1: 'Electronic material',
        line10_2: 'Display material, Copper Foil, PI film, OLED Materials, Insulation Film, Semiconductor Materials, Thermal Conductivity Materials',
        line10_3: 'Printed Circuit Board, Display Panel(FPD, OLED), Semiconductor; LiB',
        line10_4: 'Smartphone, TV Industrial Film',

        line11_1: 'New business development',
        line11_2: 'Capacitor grade PR film, resin, Chip low- temperature bonding, Release Film (PE/PET)',
        line11_3: 'Mobility, Semiconductor',
        line11_4: 'New Energy Car, Electronic Parts',


        line12_1: 'Performance Materials',
        line12_2: 'Functional materials: PVC, EVOLUE, PE, TAFMER, CR, ENPLA (PC & others). Anti- shock automobile materials, Advanced material: PI film, copper foil, releasing film, releasing paper',
        line12_3: 'Film, sheet, compound, automobile, rubber product, PCB, convertor',
        line12_4: 'Food packaging, industrial packaging, automobile - home appliance - industrial parts, smart phone, health products, wire & cable, adhesive, daily consuming products, others',
    },
    stock: {
        tit1: 'No.',
        tit2: 'Area',
        tit3: 'Type',

        area1: 'Shanghai Area',
        area2: 'East',
        area3: 'Remote Location',

        hz: 'Hangzhou',
        //ks: 'Kunshan',
        sz: 'Suzhou',
        //tc: 'Taicang',
        nb: 'Ningbo',
        nt: 'Nantong',
        zjg: 'Zhangjiagang',

        tj: 'Tianjin',
        dl: 'Dalian',    
        qd: 'Qingdao',
        sy: 'Shenyang',
        cc: 'Changchun',
        wh: 'Wuhan',
        cq: 'Chongqing',
        cd: 'Chengdu',
        xm: 'Xiamen',
        gz: 'Guangzhou',
        dw: 'Dongwan',
        shz: ' Shenzhen',


        bsq: 'Bonded',
        bswlyq: 'Bonded Logistics Park',
        yb: 'Non-Bonded',
        wxp: 'Dangerous Goods',
        ckjgq: 'Export Processing Zone',
        c1: '（1 place）',
        c2: '（0 place）',
        c3: '（1 place）',
        c5: '（5 place）',
        c6: '（6 place）',
    },
    contact: {
        title: "Please don't hesitate to contact us by following methods.",
    }
}